import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import AuthorityOS from "./pages/AuthorityOS";
import Portfolio from "./pages/Portfolio";
import Log from "./pages/Log";
import Score from "./pages/Score";
import Interview from "./pages/Interview";
import Work from "./pages/Work";
import Audit from "./pages/Audit";
import AuditConfirmed from "./pages/AuditConfirmed";
import AuditIntake from "./pages/AuditIntake";
import BlueprintIntake from "./pages/BlueprintIntake";

import Admin from "./pages/Admin";
import LegalPage from "./pages/LegalPage";
import Contact from "./pages/Contact";
import Atlas from "./pages/Atlas";
import ToolPage, { ToolsIndex } from "./pages/Tool";
import ResourcePage, { ResourcesIndex } from "./pages/Resource";
import BlogPost, { BlogIndex } from "./pages/Blog";
import About from "./pages/About";
import ProductCheckout from "./pages/ProductCheckout";
import Shop from "./pages/Shop";
import ShopCheckout from "./pages/ShopCheckout";
import ShopConfirmed from "./pages/ShopConfirmed";
import DueDiligence from "./pages/DueDiligence";

import PortalLogin from "./pages/PortalLogin";
import PortalRegister from "./pages/PortalRegister";
import PortalDashboard from "./pages/PortalDashboard";
import PortalResetPassword, { PortalForgot } from "./pages/PortalResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <AuthProvider>
    <BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/authoriteos" element={<AuthorityOS />} />
        <Route path="/authorityos" element={<AuthorityOS />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/log" element={<Log />} />
        <Route path="/score" element={<Score />} />
        <Route path="/interview" element={<Interview />} />
        <Route path="/work" element={<Work />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/audit/confirmed" element={<AuditConfirmed />} />
        <Route path="/audit/intake" element={<AuditIntake />} />
        <Route path="/blueprint/intake" element={<BlueprintIntake />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/legal/:slug" element={<LegalPage />} />
        <Route path="/atlas" element={<Atlas />} />
        <Route path="/tools" element={<ToolsIndex />} />
        <Route path="/tools/:slug" element={<ToolPage />} />
        <Route path="/resources" element={<ResourcesIndex />} />
        <Route path="/resources/:slug" element={<ResourcePage />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/about" element={<About />} />
        <Route path="/blueprint" element={<ProductCheckout />} />
        <Route path="/launch-kit" element={<ProductCheckout />} />
        <Route path="/build" element={<ProductCheckout />} />
        <Route path="/build-plus-content-engine" element={<ProductCheckout />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/confirmed" element={<ShopConfirmed />} />
        <Route path="/shop/:slug" element={<ShopCheckout />} />
        <Route path="/checkout/confirmed" element={<AuditConfirmed />} />
        <Route path="/dd" element={<DueDiligence />} />

        {/* Customer Portal */}
        <Route path="/portal/login" element={<PortalLogin />} />
        <Route path="/portal/register" element={<PortalRegister />} />
        <Route path="/portal/forgot" element={<PortalForgot />} />
        <Route path="/portal/reset-password" element={<PortalResetPassword />} />
        <Route path="/portal" element={<ProtectedRoute><PortalDashboard /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
